import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { useProductPromotionEventContext } from '../../DataLayer/Contexts/ProductPromotionEventContext.js';
import { mapProductProjectionToListingProduct } from '../../ProductListing/mappers/listing-product/map-product-projection-to-listing-product.js';
import { useGetProductsBySku } from '../../utils/use-get-products-by-sku.js';
import { ProductListingGalleryWrapper } from '../ProductListingGallery/ProductListingGalleryWrapper.js';

const ProductBannerContainer = ({ skus , className  })=>{
    const { isLoading , products , error  } = useGetProductsBySku(skus);
    const intl = useIntl();
    const listingProducts = React.useMemo(()=>products.map((product)=>mapProductProjectionToListingProduct(product, intl)
        ).filter(isDefined)
    , [
        products,
        intl
    ]);
    const classNames = classnames('product-banner', className);
    const { trackImpression , trackInteraction  } = useProductPromotionEventContext();
    return /*#__PURE__*/ React.createElement(ProductListingGalleryWrapper, {
        products: listingProducts,
        isLoading: isLoading,
        hasError: Boolean(error),
        className: classNames,
        onProductImpression: trackImpression,
        onProductInteraction: trackInteraction
    });
};

export { ProductBannerContainer, ProductBannerContainer as default };
//# sourceMappingURL=ProductBannerContainer.js.map
